import { forwardRef, useState } from "react";
import { Tooltip } from "antd";

export const Btn = forwardRef(function Btn({ children, onClick, active, title, dimmed, label, tooltipDir }, ref) {
  const [isHovered, setIsHovered] = useState(false);

  const btn = (
    <button ref={ref} onClick={onClick}
      style={{
        width: 36,
        height: 36,
        border: active ? "1px solid rgba(255, 204, 0, 0.4)" : (isHovered && !dimmed) ? "1px solid rgba(255, 255, 255, 0.05)" : "1px solid transparent",
        background: active ? "linear-gradient(135deg, rgba(255, 204, 0, 0.9), rgba(255, 170, 0, 0.9))" : (isHovered && !dimmed) ? "rgba(255, 255, 255, 0.08)" : "transparent",
        color: active ? "#000" : (isHovered && !dimmed) ? "#ffffff" : dimmed ? "#4b4b4d" : "#a1a1aa",
        cursor: dimmed ? "default" : "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 10,
        margin: "0",
        position: "relative",
        transition: "all 0.15s ease",
        boxShadow: active ? "0 4px 12px rgba(255, 204, 0, 0.35), inset 0 1px 0 rgba(255,255,255,0.4)" : "none",
        transform: active ? "scale(1.05)" : (isHovered && !dimmed) ? "translateY(-1px)" : "scale(1)",
        outline: "none",
        gap: 2,
        flexShrink: 0,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      {label && <span style={{ fontSize: 9, fontWeight: 600, letterSpacing: "0.2px", opacity: active ? 1 : 0.6, lineHeight: 1, marginTop: 1 }}>{label}</span>}
    </button>
  );

  if (!title) return btn;
  return (
    <Tooltip title={title} placement={tooltipDir || "right"} color="rgba(15, 15, 18, 0.97)" mouseEnterDelay={0.1}>
      {btn}
    </Tooltip>
  );
});

export function TBtn({ children, onClick, title, active, dimmed }) {
  const [isHovered, setIsHovered] = useState(false);
  const btn = (
    <button onClick={onClick}
      style={{
        position: "relative",
        width: 32,
        height: 32,
        borderRadius: 8,
        border: "none",
        background: active ? "linear-gradient(135deg, #ffcc00, #ffaa00)" : (isHovered && !dimmed) ? "rgba(255, 255, 255, 0.1)" : "transparent",
        color: active ? "#000" : (isHovered && !dimmed) ? "#fff" : dimmed ? "#555" : "#ddd",
        cursor: dimmed ? "default" : "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.15s ease",
        boxShadow: active ? "0 2px 10px rgba(255, 204, 0, 0.4)" : "none",
        outline: "none",
        flexShrink: 0,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
    </button>
  );

  if (!title) return btn;
  return (
    <Tooltip title={title} placement="bottom" color="rgba(15, 15, 18, 0.97)" mouseEnterDelay={0.1}>
      {btn}
    </Tooltip>
  );
}

export function Sep() {
  return <div style={{ width: 16, height: 1, background: "rgba(255,255,255,0.06)", margin: "4px auto", flexShrink: 0 }} />;
}

export function SelToolbarBtn({ children, onClick, title }) {
  const [isHovered, setIsHovered] = useState(false);
  const btn = (
    <button onClick={onClick}
      style={{ width: 32, height: 32, borderRadius: 8, border: "none", background: isHovered ? "rgba(255,255,255,0.14)" : "transparent", color: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.15s ease", outline: "none", transform: isHovered ? "scale(1.08)" : "scale(1)" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      {children}
    </button>
  );

  if (!title) return btn;
  return (
    <Tooltip title={title} placement="top" color="rgba(15, 15, 18, 0.97)" mouseEnterDelay={0.1}>
      {btn}
    </Tooltip>
  );
}

// Group label for tool sections in sidebar
export function GroupLabel({ children }) {
  return (
    <div style={{
      fontSize: 8,
      fontWeight: 700,
      color: "rgba(255,255,255,0.3)",
      letterSpacing: "1px",
      textTransform: "uppercase",
      textAlign: "center",
      padding: "0",
      marginTop: "6px",
      marginBottom: "2px",
      userSelect: "none",
      flexShrink: 0,
    }}>
      {children}
    </div>
  );
}
